/* global define */

define([], () => ({
  RECEIVE_DISCOUNT_DOWNLOAD_PROGRESS: 'RECEIVE_DISCOUNT_DOWNLOAD_PROGRESS',
  RECEIVE_DISCOUNTS: 'RECEIVE_DISCOUNTS',
  RECEIVE_DISCOUNT_CAMPAIGNS: 'RECEIVE_DISCOUNT_CAMPAIGNS',
  UPDATE_DISCOUNT_SETTING: 'UPDATE_DISCOUNT_SETTING',
  RECEIVE_ALL_DISCOUNT_CAMPAIGNS: 'RECEIVE_ALL_DISCOUNT_CAMPAIGNS',
  CLEAR_DISCOUNT_CAMPAIGNS: 'CLEAR_DISCOUNT_CAMPAIGNS',
  RECEIVE_DISCOUNT_SETTINGS: 'RECEIVE_DISCOUNT_SETTINGS',
}));

